import { axiosApi } from "../../../../../api/dbAxios";

export const requestNewRegulator = async (text: string, files: File[] = []) => {
  const test_email = "rborodinov@deloittece.com";
  const isLocalhost =
    typeof window !== "undefined" && window.location.hostname === "localhost";

  if (files.length === 0) {
    const body: any = { text, files: [] };
    if (isLocalhost) body.test_email = test_email;

    const response = await axiosApi.post(`/request_regulator/`, body);
    return response.data;
  }

  const formData = new FormData();
  formData.append("text", text);
  files.forEach((file) => formData.append("files", file));
  if (isLocalhost) formData.append("test_email", test_email);

  try {
    const response = await axiosApi.post(`/request_regulator/`, formData);
    return response.data;
  } catch (error) {
    console.error("Error requesting a new Regulator:", error);
    throw error;
  }
};
